'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/spin/style/css.js
// module id = 580
// module chunks = 0